import apiSlice from "./ApiSlice";

const attenptApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // get all delivery dates
        getAllAttemptData: builder.query({
            providesTags: ["attempt"],
            query: (body: PaginationPayloadType) => {
                return {
                    url: "/attempt",
                    method: "POST",
                    body,
                };
            },
        }),

        // delete delivery date
        deleteAttemptById: builder.mutation({
            invalidatesTags: ["attempt"],
            query: (id: any) => ({
                url: `/attempt/${id}`,
                method: "DELETE",
            }),
        }),
        // add delivery date
        addAttempt: builder.mutation({
            invalidatesTags: ["attempt"],
            query: (body) => ({
                url: `/attempt/add`,
                method: "POST",
                body,
            }),
        }),
        //get delivery date by Id
        getAttemptById: builder.query({
            providesTags: ["attempt"],
            query: (id: string) => {
                return {
                    url: `/attempt/${id}`,
                    method: "GET",
                };
            },
        }),

        // update delivery date
        updateAttemptById: builder.mutation({
            invalidatesTags: ["attempt"],
            query: ({ body, id }) => ({
                url: `/attempt/${id}`,
                method: "PUT",
                body,
            }),
        }),

        //get Attempt
        getAllAttempt: builder.query({
            providesTags: ["attempt"],
            query: () => {
                return {
                    url: `/attempt`,
                    method: "GET",
                };
            },
        }),

        // change status of delivery date
        changeStatusAttemptById: builder.mutation({
            invalidatesTags: ["attempt"],
            query: ({ body, id }) => ({
                url: `/attempt/status-change/${id}`,
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const {
    useGetAllAttemptDataQuery,
    useDeleteAttemptByIdMutation,
    useAddAttemptMutation,
    useGetAllAttemptQuery,
    useGetAttemptByIdQuery,
    useUpdateAttemptByIdMutation,
    useChangeStatusAttemptByIdMutation,
} = attenptApi;
